<template>
  <div class="search-list">
  
    <div class="search-condit">
      <div class="time-interval common">
        
        <div class="search-request clear" v-if="liveingSearchApi.subject">
            <div class="float-left border">关键词：{{liveingSearchApi.subject}} <i class="icon-del" @click="delkey"></i></div>
            <p class="float-left">共找到<span>{{totals}}</span>门<span>“{{liveingSearchApi.subject}}”</span>相关报告</p>
        </div>

        <div class="search-class">
                <div class="big-class item">
                    <p class="name">直播时段</p>
                    <div class="msg">
                        <!-- <span :class="{active: liveingSearchApi.timestatus == ''}" @click="tabTimestatus('')">全部</span> -->
                        <span v-for="(item,index) in timeList" :key="index" :class="{active: liveingSearchApi.timestatus == item.code}" @click="tabTimestatus(item.code)">{{item.name}}</span>
                        <el-date-picker style="margin-left: 20px" v-model="date" type="daterange" size='small' range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="selectDate"></el-date-picker>
                        <input type="text" style="width:0;height:0" />
                    </div>
                </div>
                
                <div class="type item">
                    <p class="name">直播状态</p>
                    <div class="msg">
                        <span v-for="(items,indexs) in leveingstatus"  :key="indexs" :class="{active: liveingSearchApi.status == items.code}" @click="tabStatus(items.code)">{{items.name}}</span>
                    </div>
                </div>
            </div>
      </div>
    </div>
    <div class="live-list">
      <!-- <div class="tab-title">
        <span v-for="item in sort" :key='item.value' :class="{activity:item.is_checked}" @click="tabcLick(item)">{{item.label}}</span>
      </div>
       -->
      <div class="tab-list">
        <template v-if="leveingsearchList.length > 0">
          <div class="tab-item" v-for="(item, index) in leveingsearchList" :key="index" @click="goto(item.livetype ,item.innerid)">
            <div class="logo"><img v-lazy="item.coverurl" alt=""></div>
            <div class="title">{{item.subject}}</div>
            <div class="desc">{{item.content}}</div>
            <div class="status" :class="{pending: item.status==0, liveing:item.status==10,end: item.status==30}">{{item.statusname}}</div>
            <div class="time">{{item.livebegintime}}</div>
          </div>
        </template>

        <template v-else>
          <div class="no-result"><span>暂无数据</span></div> 
        </template>
      </div>

      <div class="elpage">
        <el-pagination background layout="prev, pager, next" :total="totals" @current-change='changePage' :page-size="liveingSearchApi.pagesize" :current-page="liveingSearchApi.currentpage"></el-pagination>
      </div>
    </div>
   
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import $ from 'jquery'
import moment from 'moment'
import {getIndexSearch} from 'api/web-app'
  export default {
    data() {
      return {
        timeList: [ //时间段
              {code:'', name:'全部'},
              {code:'1', name:'今天'},
              {code:'2', name:'昨天'},
              {code:'3', name:'本周'},
              {code:'4', name:'本周末'},
              {code:'5', name:'本月'}
        ], 
        date: '', // 时段
        leveingsearchList: [], // 数据列表
        leveingstatus:[
          {name:"全部", code: ""},{name:"未开始", code: "0"},{name:"直播中", code: "10"},{name:"直播结束", code: "30"}
        ], //状态
        liveingSearchApi:{  //搜索字段
          subject: this.$route.query.data ? decodeURI(this.$route.query.data) : '',  // 搜索字段
          timestatus: '', // 时间段状态：''是全部，1是今天，2是昨天，3是本周，4是本周末，5是本月，6是制定时间
          timestart: '', // 时间段开始日期
          timeend: '', // 时间段结束日期
          status: '', // 直播状态
          sort: '', // 直播排序
          currentpage: 1, // 第几页
          pagesize: 9 // 页面数据大小
        },
        totals: 0,//总页数
      }
    },
    mounted () {
      $('body').css('background', '#f8f8f8')

      // 搜索
      this.getSearchResult(1)
    },
    destroyed () {
      $('body').css('background', '#fff')
    },
    methods: {
      getSearchResult(page) { // 搜索

        this.liveingSearchApi.currentpage = page
        this.setLoading(true) 

        getIndexSearch({
          data: this.liveingSearchApi,
          success: data => {
            this.setLoading(false)
            console.log(data.data)

            this.leveingsearchList = data.data.content
            this.totals = data.data.pageinfo.rowCount // 总页数
            
          },
          error: data => {
            this.setLoading(false)
            this.$message.error(data.msg)
          }   
        })
      },
      tabTimestatus(timestatus) { // 直播时间段发生变化
        this.liveingSearchApi.timestatus = timestatus
        this.getSearchResult(1)
      },
      tabStatus(status) { // 直播状态发生变化
        this.liveingSearchApi.status = status
        this.liveingSearchApi.timestart = this.liveingSearchApi.timeend = ""
        this.getSearchResult(1)
      },
      changePage(page) {  // 页数发生变化
        this.getSearchResult(page)
      },
      goto(type, innerid) {  // 前往详情页
        if (type == 1) {
            // 视频直播
            const host = this.$router.resolve({
              name: "VideoLiveing",
              query: {innerid: innerid}
            })
            window.open(host.href, "_blank")
        } else {
            // 图文直播
            const tw = this.$router.resolve({
              name: "LiveingDetails",
              query: {innerid: innerid}
            })
            window.open(tw.href, "_blank")
        }
      },
      delkey() { // 清空选中关键词
        this.$router.push({name: 'LiveingSearch'})
      },
      selectDate(dates) {  // 选取时间

        if (dates == null && this.liveingSearchApi.timestatus == 6) {
          this.liveingSearchApi.timestatus = ''
        } else {
          this.liveingSearchApi.timestatus = 6
          this.liveingSearchApi.timestart = moment(dates[0]).format("YYYY-MM-DD") // 时间段开始日期
          this.liveingSearchApi.timeend = moment(dates[1]).format("YYYY-MM-DD") // 时间段结束日期
        }
        this.getSearchResult(1)
      },
      ...mapActions(['setLoading'])
    },
    watch: {
        $route: {
            handler (val) { // val 更新的, oldVal 过去的
       
                this.liveingSearchApi.subject = val.query.data
                
                this.getSearchResult(1)

            },
            // 深度观察监听
            deep: true
        }
    },
    components:{
    }
  }
</script>

<style lang='scss' type="css/scss">
  .search-list{
    // padding-top: 80px;

    .elpage {
      text-align: center;
      .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
        background: #fff;
      }
      .el-pagination.is-background .el-pager li:not(.disabled).active {
        background: #409EFF;
      }
    }

    .icon-del {
        display: inline-block;
        width: 10px;
        height: 10px;
        cursor: pointer;
        background: url('../../../common/images/search/del.png');
        background-size: 10px;
    }
    .el-range-editor.el-input__inner {
      margin-top: -6px;
    }
    .el-range-editor--small .el-range-separator {
      line-height: 32px !important;
    }
    .time-interval {
      margin: auto;
      width: 1180px;
    }
    .search-request {
      margin-top: 20px;
            margin-bottom: 20px;
            .border {
                padding: 0 8px;
                height: 28px;
                line-height: 28px;
                font-size: 14px;
                border: dashed  1px #409EFF;
            }
            p {
                margin-left: 30px;
                line-height: 28px;
                font-size: 14px;

                span {
                    display: inline-block;
                    padding:  0 5px;
                    color: #409EFF
                }
            }
        }

      .search-class {
            margin-top: 20px;
            padding: 0 20px;
            overflow: hidden;
            background:rgba(255,255,255,1);
            // box-shadow:0px 0px 6px 0px rgba(0,0,0,0.2);
            border: solid 1px #eee;

            .item {
                padding-top: 20px;
                overflow: hidden;
                
                &~.item {
                    border-top: solid 1px #eee;
                }
            }
            .name {
                float: left;
                display: block;
                width: 83px;
            }    
            .msg {
                float: left;
                width: calc(100% - 83px);
            }

            span {
                float: left;
                display: inline-block;
                height: 20px;
                line-height: 20px;
                margin-bottom: 15px;
                font-size: 12px;
                margin-left: 30px;
                cursor: pointer;

                &.active {
                    font-size: 12px;
                    padding: 0 7px;
                    color: #fff;
                    background:#409EFF;
                    border-radius:10px;
                }
            }
        }

    //height: 100%;
    .header-wrap{
      height: 55px;
      background:rgba(255,255,255,1);
      box-shadow:0px 1px 10px 0px rgba(0, 0, 0, 0.1);
      .header-box{
        width: 1160px;
        margin:auto;
        background: url(./../../../common/images/leveing/live-detail/activity-home.png) no-repeat;
        background-size: 335px 35px;
        height: 100%;
        background-position: left;
        padding-left: 360px;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-end;
        .el-input {
          position: relative;
          font-size: 14px;
          display: inline-block;
          width: 260px;
          top: -8px;
        }
        .user{
        line-height: 55px;
        color: #666;
        font-size: 16px;
        }
        .user-img-icon{
          vertical-align: text-bottom;
        }
        .live-desc{
          background: #1464C8;
          color: #fff;
          border-radius: 16px;
          height: 32px;;
          line-height: 32px;
          font-size: 13px;
          text-align: center;
          width: 140px;
          margin-top: 10px;
          margin-left: 20px;
        }
        .search-input{
          margin-left: 135px;
        }
      
      }
    }
   
   
    .live-list{
      width: 1160px;
      margin: 24px auto 60px;

      .tab-title{
        height: 30px;
        span{
          height:18px;
          font-size:16px;
          font-family:MicrosoftYaHei;
          font-weight:400;
          color:rgba(51,51,51,1);
          line-height:18px;
          margin-right: 30px;
          cursor: pointer;
        }
        span.activity{
          color: #1464C8;
          border-bottom: 2px solid #1464C8;
          padding-bottom: 8px;
          cursor: pointer;
        }
      }
      .tab-list{
        margin-top: 30px;
        display: flex;
        //justify-content: space-between;
        flex-wrap:wrap;
        margin-left: -23px;
        .tab-item{
          margin-left: 23px;
          width:370px;
          height:346px;
          background:rgba(255,255,255,1);
          box-shadow:0px 1px 10px 0px rgba(0, 0, 0, 0.1);
          position: relative;
          margin-bottom: 42px;
          .logo{
            height: 208px;
            overflow: hidden;
            img{
              width: 100%;
              height: 100%;
              transition: 1s;
              background: #ccc;
              cursor: pointer;
               &:hover{
                transform: scale(1.2);
              }   
            }
          }
          .title{
            //height:18px;
            font-size:18px;
            font-weight:bold;
            color:rgba(51,51,51,1);
            padding: 0px 14px;
            margin: 14px 0px 20px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
          .desc{
            height:34px;
            font-size:13px;
            font-weight:400;
            color:rgba(204,204,204,1);
            line-height:18px;
            padding: 0px 14px;
            min-height: 34px;
            text-overflow:ellipsis;
            display:-webkit-box; 
            -webkit-box-orient:vertical;
            -webkit-line-clamp:2; 
            overflow: hidden;
          }
          //.desc::after{content: "..."; position: absolute; bottom: 0; right: 14px};
          .status{
            width: 90px;
            height: 36px;
            position: absolute;
            top: 0px;
            left: 0px;
            padding-left: 10px;
            line-height: 36px;
            color: #fff;
            font-size: 10.8px;
          }
          .status.pending{
            background: url(./../../../common/images/leveing/live-detail/pending.png) no-repeat;
            background-size: 90px 36px;
          }
          .status.liveing{
            background: url(./../../../common/images/leveing/live-detail/liveing.png) no-repeat;
            background-size: 90px 36px;
          }
          .status.end{
            background: url(./../../../common/images/leveing/live-detail/end.png) no-repeat;
            background-size: 90px 36px;
          }
          .time{
            height:12px;
            font-size:13px;
            font-family:MicrosoftYaHei;
            font-weight:400;
            color:rgba(153,153,153,1);
            padding: 0px 14px;
            margin-top: 18px;
          }
        }
      }
    }
    .no-result {
          background: url("./../../../common/images/leveing/web/no-live.png") no-repeat;
          height: 421px;
          background-position: 50% 25%;
          position: relative;
          text-align: center;
          width: 100%;
          span {
            position: absolute;
            top: 240px;
            margin-left: -40px;
            color: #999;
          }
        }
    
    .el-checkbox__inner{
        z-index: 0;
    }
  }
</style>